// Thin host wrapper — single slip. Direction A (dense pricing-audit
// terminal) vs Direction B (probability-document reading layout),
// chosen by the localStorage preference documented in
// SlipDetailDocumentPage.tsx (mirrors the super-acca direction toggle).
// Tier gate per SlipDetailPage contract: FOCUS/VALUE → sika_pro,
// POWER → phantom_pro. Place/share NAVIGATE only — never charge.
import { useParams, useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaSlip } from "../../intl-acca/useIntlAccaSlip.ts";
import { openShareCard } from "../../intl-acca/shareCardEndpoint.ts";
import { SlipDetailPage } from "./SlipDetailPage.tsx";
import { SlipDetailDocumentPage } from "./SlipDetailDocumentPage.tsx";

const SLIP_DIRECTION_KEY = "strikza:intlacca:slip-direction";

function readDirection(): "A" | "B" {
  try {
    return window.localStorage.getItem(SLIP_DIRECTION_KEY) === "B" ? "B" : "A";
  } catch {
    return "A";
  }
}

export function IntlAccaSlipRoute(): JSX.Element {
  const { slipId = "" } = useParams();
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaSlip(slipId);

  const hasAccess = vm.slip
    ? tierMeets(tierCode, vm.slip.slip_type === "POWER" ? "phantom_pro" : "sika_pro")
    : false;

  const shared = {
    loading: vm.loading,
    error: vm.error,
    tournament: vm.tournament,
    slip: vm.slip,
    matchLabels: vm.matchLabels,
    hasAccess,
    onUpgrade: () => navigate("/intl-acca/pass"),
    onShare: () => vm.slip && openShareCard(vm.slip.id),
    onPlace: () => navigate("/intl-acca/pass"),
  };

  return readDirection() === "B"
    ? <SlipDetailDocumentPage {...shared} />
    : <SlipDetailPage {...shared} />;
}
